import React from 'react';
import { BaseConfigProps, commonStyles } from '../shared/ConfigFormHelpers';

const AIImageGeneratorConfig: React.FC<BaseConfigProps> = ({ node, updateConfig }) => {
  return (
    <div className="space-y-4">
      <div>
        <label className={commonStyles.label}>
          AI Provider
        </label>
        <select
          value={node.data.config?.provider || 'dalle'}
          onChange={(e) => updateConfig('provider', e.target.value)}
          className={commonStyles.select}
        >
          <option value="dalle">DALL-E (OpenAI)</option>
          <option value="midjourney">Midjourney</option>
          <option value="stable_diffusion">Stable Diffusion</option>
        </select>
      </div>

      <div>
        <label className={commonStyles.label}>
          Prompt
        </label>
        <textarea
          value={node.data.config?.prompt || ''}
          onChange={(e) => updateConfig('prompt', e.target.value)}
          placeholder="Írd le, milyen képet szeretnél generálni..."
          rows={3}
          className={commonStyles.textarea}
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className={commonStyles.label}>
            Méret
          </label>
          <select
            value={node.data.config?.size || '1024x1024'}
            onChange={(e) => updateConfig('size', e.target.value)}
            className={commonStyles.select}
          >
            <option value="256x256">256x256</option>
            <option value="512x512">512x512</option>
            <option value="1024x1024">1024x1024</option>
            <option value="1792x1024">1792x1024</option>
          </select>
        </div>

        <div>
          <label className={commonStyles.label}>
            Stílus
          </label>
          <select
            value={node.data.config?.style || 'natural'}
            onChange={(e) => updateConfig('style', e.target.value)}
            className={commonStyles.select}
          >
            <option value="natural">Természetes</option>
            <option value="vivid">Élénk</option>
            <option value="artistic">Művészi</option>
            <option value="photographic">Fotórealisztikus</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default AIImageGeneratorConfig;
